import { useSelector } from "react-redux";
import clsx from "clsx";

import useLanguageChange from "../../hooks/useLanguageChange";

import { CALL_DATA, PublicVariables } from "../../constants/PublicVariables";
import { UPLOAD_TYPE } from "../../constants/UploadFilesConstants";
import { CALL_BODY_SCREEN, ENABLED } from "../../constants/Constants";
import { EVENT_NAME } from "../../constants/GTagConstants";

import uploadFilesService from "../../services/uploadFilesService";
import googleEvent from "../../services/googleEvent";
import { isRemainingFileCountLess } from "../../shared/utility";

const UploadFilesButton = () => {
    const { isRemoteParticipantJoined, currentCallBodyScreen } = useSelector((state) => state.commonReducer);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change */
    const localisedValues = useLanguageChange();

    const isUploadFileButtonDisabled = () => {
        return !isRemoteParticipantJoined || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN || isRemainingFileCountLess();
    };

    const showUploadButtonOnActionBar = () => {
        if (CALL_DATA.isObserver) {
            return false;
        }

        return PublicVariables?.featureFlag?.UPLOADFILE === ENABLED;
    };

    const uploadClickHandler = (uploadFileType) => {
        uploadFilesService.showUploadFilesView(uploadFileType, localisedValues?.uploaded_max_file);
    };

    const uploadButtonClickHandler = () => {
        googleEvent.logEvent(EVENT_NAME.UPLOAD_FILE_TAPPED);

        uploadClickHandler(null);
    };

    const uploadFromDeviceButtonClickHandler = () => {
        googleEvent.logEvent(EVENT_NAME.UPLOAD_FILE_FROM_DEVICE_TAPPED);

        uploadClickHandler(UPLOAD_TYPE.FROM_DEVICE);
    };

    const uploadFromCameraButtonClickHandler = () => {
        googleEvent.logEvent(EVENT_NAME.UPLOAD_FILE_FROM_CAMERA_TAPPED);

        uploadClickHandler(UPLOAD_TYPE.FROM_CAMERA);
    };

    return (
        showUploadButtonOnActionBar() && (
            <div className={clsx("action-button upload-dropdown", isUploadFileButtonDisabled() && "disabled")}>
                <div className='action-button-in custom-tooltip top-tooltip left-tooltip tooltip-auto-width'>
                    <button className='call-action-btn' disabled={isUploadFileButtonDisabled()} onClick={() => uploadButtonClickHandler()}>
                        <span className='action-button-icon'>
                            <span className='for-icon icon-upload'></span>
                        </span>
                        <span className='for-text'>{localisedValues?.upload}</span>
                    </button>
                    {!isUploadFileButtonDisabled() && (
                        <div className='upload-dropdown-menu'>
                            <div className='upload-dropdown-menu-in'>
                                <ul>
                                    <li>
                                        <div className='upload-dropdown-button'>
                                            <button className='btn' onClick={() => uploadFromDeviceButtonClickHandler()}>
                                                <span className='for-icon icon-upload-device'></span>
                                                <span className='for-text'>{localisedValues?.from_device}</span>
                                            </button>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='upload-dropdown-button'>
                                            <button className='btn' onClick={() => uploadFromCameraButtonClickHandler()}>
                                                <span className='for-icon icon-camera'></span>
                                                <span className='for-text'>{localisedValues?.from_camera}</span>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )}
                    {isRemainingFileCountLess() && (
                        <div className='custom-tooltip-content text-nowrap'>
                            <div className='custom-tooltip-in'>
                                <p>{localisedValues?.uploaded_max_file}</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    );
};

export default UploadFilesButton;
